import { render, staticRenderFns } from "./VerificationRequest.vue?vue&type=template&id=2f68ebe8&scoped=true&"
import script from "./VerificationRequest.vue?vue&type=script&lang=js&"
export * from "./VerificationRequest.vue?vue&type=script&lang=js&"
import style0 from "./VerificationRequest.vue?vue&type=style&index=0&id=2f68ebe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68ebe8",
  null
  
)

export default component.exports